/**
 * @file GalleryLayoutField.tsx
 * @description «Раскладка фото» у элемента «Фото товара» схемами
 * (phase19.16, партия SB120, этап 3б; uiux-sb120-stage3 §3 «Фото товара»;
 * данные db-design-sb120-stage3 §1): [Миниатюры снизу][Слева][Справа]
 * [Сеткой] — набор и подписи shared (`PRODUCT_GALLERY_LAYOUTS`).
 * `thumbs-side` — «Слева»: значение не переименовывается, это только подпись.
 */

import { PRODUCT_GALLERY_LAYOUT_LABELS, PRODUCT_GALLERY_LAYOUTS, type ProductGalleryLayout } from "@chaiberi/shared";

import { Label } from "../../../../ui/label";
import { OptionCards } from "../../../../site-view/OptionCards";

const BIG = "rounded-sm bg-primary/50";
const THUMB = "rounded-[2px] bg-primary/30";

/** Мини-схема: крупное фото и полоска миниатюр с нужной стороны или сетка 2×2. */
function GalleryScheme({ layout }: { layout: ProductGalleryLayout }) {
  if (layout === "grid") {
    return (
      <span aria-hidden className="mx-auto grid w-10 grid-cols-2 gap-0.5">
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className={`${BIG} h-4`} />
        ))}
      </span>
    );
  }
  const thumbs = (dir: "row" | "col") => (
    <span className={dir === "row" ? "flex gap-0.5" : "flex flex-col gap-0.5"}>
      {[0, 1, 2].map((i) => (
        <span key={i} className={`${THUMB} size-2`} />
      ))}
    </span>
  );
  if (layout === "thumbs-below") {
    return (
      <span aria-hidden className="mx-auto flex w-10 flex-col items-start gap-0.5">
        <span className={`${BIG} h-7 w-10`} />
        {thumbs("row")}
      </span>
    );
  }
  const left = layout === "thumbs-side";
  return (
    <span aria-hidden className={`mx-auto flex w-11 gap-0.5 ${left ? "" : "flex-row-reverse"}`}>
      {thumbs("col")}
      <span className={`${BIG} h-9 flex-1`} />
    </span>
  );
}

const OPTIONS = PRODUCT_GALLERY_LAYOUTS.map((value) => ({ value, label: PRODUCT_GALLERY_LAYOUT_LABELS[value], preview: <GalleryScheme layout={value} /> }));

interface Props {
  value: ProductGalleryLayout;
  onChange: (layout: ProductGalleryLayout) => void;
}

export function GalleryLayoutField({ value, onChange }: Props) {
  return (
    <div className="flex min-w-0 flex-col gap-1">
      <Label>Раскладка фото</Label>
      <OptionCards aria-label="Раскладка фото" columns={4} options={OPTIONS} value={value} onChange={onChange} />
    </div>
  );
}
